// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"218":"component---src-pages-404-tsx","532":"styles","691":"component---src-pages-index-tsx"}[chunkId] + "-" + {"218":"c41fc3696568102670a9","532":"a1bdeb90782020769f79","691":"650d5a4442f90bdd3ba3"}[chunkId] + ".js";
};